import { fallback, FallbackTransport, http } from 'viem';
import { cookieStorage, createStorage } from 'wagmi';
import { WagmiAdapter } from '@reown/appkit-adapter-wagmi';
import {
  mainnet,
  bsc,
  polygon,
  avalanche,
  arbitrum,
  optimism,
  base,
  type AppKitNetwork,
} from '@reown/appkit/networks';

export const projectId = String(process.env.NEXT_PUBLIC_REOWN_PROJECT_ID);

export const networks = [mainnet, bsc, polygon, avalanche, arbitrum, optimism, base] as [
  AppKitNetwork,
  ...AppKitNetwork[],
];

export const chains = [mainnet, bsc, polygon, avalanche, arbitrum, optimism, base] as const;

export const transports: Record<(typeof chains)[number]['id'], FallbackTransport> = {
  [mainnet.id]: fallback([
    http('https://ethereum-rpc.publicnode.com'),
    http('https://rpc.mevblocker.io'),
    http('https://eth.merkle.io'),
  ]),
  [bsc.id]: fallback([
    http('https://bsc-dataseed1.defibit.io'),
    http('https://bsc-dataseed1.bnbchain.org'),
    http('https://56.rpc.thirdweb.com'),
  ]),
  [polygon.id]: fallback([
    http('https://polygon.drpc.org'),
    http('https://polygon-bor-rpc.publicnode.com'),
    http('https://polygon.gateway.tenderly.co'),
  ]),
  [avalanche.id]: fallback([
    http('https://api.avax.network/ext/bc/C/rpc'),
    http('https://avalanche.public-rpc.com'),
    http('https://avalanche.drpc.org'),
  ]),
  [arbitrum.id]: fallback([
    http('https://arb1.arbitrum.io/rpc'),
    http('https://arbitrum-one.public.blastapi.io'),
    http('https://arbitrum.drpc.org'),
  ]),
  [optimism.id]: fallback([
    http('https://mainnet.optimism.io'),
    http('https://optimism-rpc.publicnode.com'),
    http('https://optimism.drpc.org'),
  ]),
  [base.id]: fallback([
    http('https://mainnet.base.org'),
    http('https://base.publicnode.com'),
    http('https://base.drpc.org'),
  ]),
};

export const wagmiAdapter = new WagmiAdapter({
  networks,
  chains,
  projectId,
  ssr: true,
  storage: createStorage({ storage: cookieStorage }),
  batch: { multicall: true },
  cacheTime: 750,
  transports,
});

export const config = wagmiAdapter.wagmiConfig;
